import { HistoryMessageSegment } from "types/historyMessageTypes";

/**
 * Builds formatted message for SYSTEM history type
 * Add implementation when product owner defines format
 */
export class SystemMessageBuilder {
  static build(system: any): HistoryMessageSegment[] {
    // TODO: Define format for SYSTEM type
    return [];
  }
}
